import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import {connect} from 'react-redux';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';

import VM from 'openblock-vm';

import {setStageSize} from '../reducers/stage-size';
import {STAGE_SIZE_MODES, STAGE_DISPLAY_SIZES} from '../lib/layout-constants';
import {openUploadProgress} from '../reducers/modals';
import {showAlertWithTimeout} from '../reducers/alerts';
import {getNanoBootloaderVariant, setNanoBootloaderVariant} from '../lib/board-variant-preference.js';

import HardwareHeaderComponent from '../components/hardware-header/hardware-header.jsx';

class HardwareHeader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCompile',
            'handleUploadLastCompiled',
            'handleCompileAndUpload',
            'handleNanoVariantChange'
        ]);
        this.state = {
            nanoBootloaderVariant: getNanoBootloaderVariant()
        };
    }

    // PATCH (openblock-web-compiler): tek "Upload" butonu yerine Arduino
    // IDE'deki gibi üç ayrı işlem — Derle / Yükle (son derleneni) /
    // Derle+Yükle.
    isWorkspaceEmpty () {
        const blocklyBlockCanvas = document.querySelector('.blocklyWorkspace .blocklyBlockCanvas');
        return blocklyBlockCanvas.childNodes.length === 0;
    }

    handleCompile () {
        if (this.isWorkspaceEmpty()) {
            this.props.onWorkspaceIsEmpty();
            return;
        }
        this.props.vm.compileForPeripheral(this.props.deviceId, this.props.codeEditorValue);
        this.props.onOpenUploadProgress();
    }

    handleUploadLastCompiled () {
        this.props.vm.uploadLastCompiledToPeripheral(this.props.deviceId);
        this.props.onOpenUploadProgress();
    }

    handleCompileAndUpload () {
        if (this.isWorkspaceEmpty()) {
            this.props.onWorkspaceIsEmpty();
        } else {
            this.props.vm.uploadToPeripheral(this.props.deviceId, this.props.codeEditorValue);
            this.props.onOpenUploadProgress();
        }
    }

    handleNanoVariantChange (variant) {
        setNanoBootloaderVariant(variant);
        this.setState({nanoBootloaderVariant: variant});
    }

    render () {
        const {
            ...props
        } = this.props;
        return (
            <HardwareHeaderComponent
                nanoBootloaderVariant={this.state.nanoBootloaderVariant}
                onCompile={this.handleCompile}
                onCompileAndUpload={this.handleCompileAndUpload}
                onNanoVariantChange={this.handleNanoVariantChange}
                onUploadLastCompiled={this.handleUploadLastCompiled}
                {...props}
            />
        );
    }
}

HardwareHeader.propTypes = {
    codeEditorValue: PropTypes.string,
    deviceId: PropTypes.string,
    onNoPeripheralIsConnected: PropTypes.func.isRequired,
    onOpenUploadProgress: PropTypes.func,
    onWorkspaceIsEmpty: PropTypes.func.isRequired,
    peripheralName: PropTypes.string,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    codeEditorValue: state.scratchGui.code.codeEditorValue,
    deviceId: state.scratchGui.device.deviceId,
    peripheralName: state.scratchGui.connectionModal.peripheralName
});

const mapDispatchToProps = dispatch => ({
    onNoPeripheralIsConnected: () => showAlertWithTimeout(dispatch, 'connectAPeripheralFirst'),
    onSetStageLarge: () => dispatch(setStageSize(STAGE_SIZE_MODES.large)),
    onSetStageSmall: () => dispatch(setStageSize(STAGE_SIZE_MODES.small)),
    onSetStageHide: () => dispatch(setStageSize(STAGE_SIZE_MODES.hide)),
    onOpenUploadProgress: () => dispatch(openUploadProgress()),
    onWorkspaceIsEmpty: () => showAlertWithTimeout(dispatch, 'workspaceIsEmpty')
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(HardwareHeader);
